export * from './fields/HazardCauseInput.fields';
export * from './fields/HazardControlInput.fields';
export * from './fields/HazardActionInput.fields';

export const HazardFieldLabels = {
  title: 'Title',
  category: 'Category',
  otherCategory: 'Other Category',
  description: 'Description',
  harm: 'Harm',
  hazardOwner: 'Hazard Owner',
  techLead: 'Tech Lead',
  initialSeverity: 'Initial Severity',
  initialProbability: 'Initial Probability',
  initialRisk: 'Initial Risk',
  residualSeverity: 'Residual Severity',
  residualProbability: 'Residual Probability',
  residualRisk: 'Residual Risk',
  riskJustification: 'Risk Justification',
  benefitRiskAnalysis: 'Benefit-Risk Analysis',
  comments: 'Comments',
  assignUserNeeds: 'Assign User Needs',
  assignDesignInputs: 'Assign Design Inputs',
  taskFiles: 'Document References'
} as const;

export type HazardField = keyof typeof HazardFieldLabels;

export const HazardFields: HazardField[] = Object.keys(
  HazardFieldLabels
) as HazardField[];
